import baseStyles from '../Base/Base.styles'

export default ({
  base
}) => {

  let jss = {
    root: {
      ...baseStyles(base)
    }
  }

  return jss
}
